import { OnInit, Component } from "@angular/core";
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import { PlaceholderChildComponent,ICloseReturnType} from '@ispm/layout/classes/placeholder-child-component.abstract';

import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { DynamicFormModalResponse } from '@ispm/dynamic-form/classes/dynamic-form-modal-response.class';

@Component({
    selector: 'screening-guideline',
    templateUrl: './screening-guideline.component.html',
    styleUrls: ['./screening-guideline.component.scss'],
})
@Widget('ScreeningGuideline')
export class ScreeningGuidelineComponent extends PlaceholderChildComponent<IScreeningGuidelineModalPayLoad,DynamicFormModalResponse> implements IWidgetItem{
    widgetUpdateValueCallback: (value) => void;

    constructor(){
      super();
    }

    set widgetData(widgetData: any) {        
    }
  
    set widgetConfig(_itemConfig: any) {       
    }

    beforeClose(_modalResponse?: modalResponse): DynamicFormModalResponse & ICloseReturnType {
    }
}

interface IScreeningGuidelineModalPayLoad {
    guideLineImage: any;
    guideLineExternalLink: string;
    guidelineLinkTitle: string;
}